var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("FormItem", {
    scopedSlots: _vm._u(
      [
        {
          key: "question",
          fn: function () {
            return [_vm._v("Payment Details")]
          },
          proxy: true,
        },
        {
          key: "action",
          fn: function () {
            return [
              _c(
                "v-row",
                { staticClass: "gap-2", attrs: { "no-gutters": "" } },
                [
                  _vm.value
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "soli-round",
                              attrs: {
                                "x-small": "",
                                outlined: "",
                                color: "accent",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showPaymentElement = true
                                },
                              },
                            },
                            [_vm._v("New Payment Method")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "response",
          fn: function () {
            return [
              _c("ShoppingCartPromo", {
                ref: "promo",
                attrs: {
                  errors: _vm.errors,
                  prices: _vm.items.map((e) => {
                    return { id: e.price_id, quantity: e.quantity }
                  }),
                  guest: _vm.guest,
                  user: _vm.user,
                },
                on: {
                  applyPromo: function ($event) {
                    return _vm.applyPromo($event)
                  },
                  applyGift: function ($event) {
                    return _vm.applyGift($event)
                  },
                },
              }),
              _vm._v(" "),
              _vm.user?.pm_last_four
                ? _c("UserPaymentMethods", {
                    key: _vm.user?.pm_last_four,
                    attrs: { user: _vm.user },
                    on: {
                      input: function ($event) {
                        return _vm.setPaymentMethod($event)
                      },
                      stripeLoaded: function ($event) {
                        return _vm.$emit("stripeLoaded")
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showPaymentElement
                ? _c("SoliResponsiveDialog", {
                    ref: "addPaymentMethod",
                    attrs: { title: "New Payment Method", mobileScroll: false },
                    on: {
                      reset: function ($event) {
                        _vm.closeModal(() => (_vm.showPaymentElement = false))
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-form",
                                    {
                                      on: {
                                        submit: function ($event) {
                                          $event.preventDefault()
                                          return _vm.storePaymentMethod(true)
                                        },
                                      },
                                    },
                                    [
                                      _c("StripePaymentElement", {
                                        ref: "stripeElement",
                                        attrs: { errors: _vm.errors },
                                        on: {
                                          stripeLoaded: function ($event) {
                                            return _vm.$emit("stripeLoaded")
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("FormSubmit", {
                                        attrs: {
                                          text: "Add Payment Method",
                                          gradient: "gradient-orange",
                                          type: "submit",
                                          loading: _vm.loading,
                                          errors: _vm.errors,
                                          valid: "",
                                          large: false,
                                          contained: "",
                                          icon: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1445223953
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.user?.pm_last_four
                ? _c("StripePaymentElement", {
                    ref: "stripeElement",
                    attrs: { errors: _vm.errors },
                    on: {
                      stripeLoaded: function ($event) {
                        return _vm.$emit("stripeLoaded")
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._t("validate"),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }